import { SideNavbarTranslate } from './sidenavbarTranslate.model';

const sidenavbarTranslateEN: SideNavbarTranslate = {
  tooltip: {
    openSidebar: 'Open sidebar',
    closeSidebar: 'Close sidebar',
  },
  theme: {
    light: 'Light theme',
    dark: 'Dark theme',
    system: 'System theme',
  },
  header: {
    organizations: 'Organizations',
    greeting: 'Hello, {{name}}',
    userMenu: 'Open account menu',
  },
  groups: {
    analytics: 'Analytics',
    management: 'Manage',
  },
  body: {
    home: 'Home',
    leads: 'Leads',
    events: 'Events',
    todos: 'Tasks',
    catalog: 'Catalog',
    contracts: 'Contracts',
    billing: 'Billing',
    team: 'Team',
    statistics: 'Statistics',
    reports: 'Reports',
  },
  footer: {
    settings: 'Settings',
    logout: 'Logout',
  },
  actions: {
    closeModal: 'Close',
    closeMenu: 'Close menu',
    add: 'Add',
  },
};

export default sidenavbarTranslateEN;
